'use client';

import { useSearchParams } from 'next/navigation';

import { NoDataMessage } from '@/components/molecules';
import { LeagueCard } from '@/components/molecules/LeaguesCard';
import { League } from '@/entities/League';

interface PlayerLeaguesProps {
	leagues: League[];
}

export const PlayerLeaguesList = ({ leagues }: PlayerLeaguesProps) => {
	const searchParams = useSearchParams();

	return (
		<>
			{leagues.length !== 0 ? (
				<div className="flex flex-wrap justify-center gap-8 lg:justify-normal">
					{leagues.map((league: League) => (
						<LeagueCard key={league.uuid} league={league} />
					))}
				</div>
			) : (
				<NoDataMessage
					title={searchParams ? 'Nothing in the Kitchen!' : 'No rally here!'}
					description={
						searchParams
							? "Sorry, we didn't find any results, so please try re-serving that search with new keywords."
							: "There's no data to show yet. Stretch it out and check back later!"
					}
				/>
			)}
		</>
	);
};
